import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import * as _ from 'lodash';
import { BaseModalPageComponent } from '../../base-modal.component';
import { InspectionPluginService } from '../../shared/services/index';
import { ApplicationType } from '../../utils';

@Component({
    templateUrl: './add-plugin.component.html',
    standalone: false
})
export class AddPluginPageComponent extends BaseModalPageComponent implements OnInit {
  inspectionId: string;
  pointId: string;
  pluginId: string;
  applicationSubType: number;
  pluginType: string = 'inspection';
  models: any;
  selectedModels: any = [];
  orderByFieldName = 'name';
  direction = 'asc';
  query = '';
  public processing = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    location: Location,
    private pluginSelectorService: InspectionPluginService,
    private cdRef: ChangeDetectorRef
  ) {
    super(location);
  }

  initRoute(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['inspectionId'];
      if (id == null) {
        this.goToBack();
      }

      this.inspectionId = id;

      const pointId = params['pointId'];
      if (pointId) {
        this.pointId = pointId;
        this.pluginType = 'point';
      }

      const pluginId = params['pluginId'];
      if (pluginId) {
        this.pluginType = 'plugin';
        this.pluginId = pluginId;
      }

      this.applicationSubType = +params['applicationSubType'];
      this.initData();
    });
  }

  save() {
    this.processing = true;
    const pluginTypes = _.map(this.selectedModels, (el: any) => el.PluginType);
    this.pluginSelectorService
      .addPlugin(this.inspectionId, this.pointId ? this.pointId : null, pluginTypes)
      .subscribe((el) => {
        this.processing = false;
        this.goToBack();
      });
  }

  selectModel(model) {
    model.selected = !model.selected;

    if (model.selected) {
      this.selectedModels.push(model);
    } else {
      const i = _.findIndex(this.selectedModels, (p: any) => p.PluginType === model.PluginType);
      this.selectedModels.splice(i, 1);
    }

    this.cdRef.detectChanges();
  }

  cancel() {
    this.goToBack();
  }

  initData() {
    (this.currentAppType === ApplicationType.Installation
      ? this.pluginSelectorService.getPluginsByApplicationSubType(this.pluginType, this.applicationSubType)
      : this.pluginSelectorService.getPluginModels(this.pluginType)
    ).subscribe((data) => {
      this.models = data;
      this.processData();
    });
  }

  ngOnInit(): void {
    this.initRoute();
  }

  public setOrderBy(newOrderBy: string) {
    this.direction = this.orderByFieldName === newOrderBy ? (this.direction === 'asc' ? 'desc' : 'asc') : 'desc';
    this.orderByFieldName = newOrderBy;
  }

  processData() {
    this.models = _.orderBy(this.models, ['Name']);
    _.forEach(this.models, (el) => {
      el.search = (query: string): boolean => el.Name == null || el.Name.toLowerCase().indexOf(query) !== -1;
    });
  }
}
